import type { IRestApiContext } from '../types';
import { makeRestApiRequest } from '../utils';

export interface ProvisioningConfig {
	scopesInstanceRoleClaimName: string;
	scopesName: string;
	scopesProjectsRolesClaimName: string;
	scopesProvisionInstanceRole: boolean;
	scopesProvisionProjectRoles: boolean;
	scopesUseExpressionMapping: boolean;
	/**
	 * Default condition: role slug (or BLOCK_ACCESS_ASSIGNMENT) applied when a
	 * login doesn't resolve to an instance role. Unset preserves legacy behavior.
	 */
	defaultInstanceRole?: string;
}

export type ProvisioningConfigPatch = Partial<ProvisioningConfig> & {
	deleteProjectRules?: boolean;
};

export const getProvisioningConfig = async (
	context: IRestApiContext,
): Promise<ProvisioningConfig> => {
	return await makeRestApiRequest(context, 'GET', '/sso/provisioning/config');
};

export const saveProvisioningConfig = async (
	context: IRestApiContext,
	config: ProvisioningConfigPatch,
): Promise<ProvisioningConfig> => {
	return await makeRestApiRequest(context, 'PATCH', '/sso/provisioning/config', config);
};
